export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const formatPhone = (phone: string) => {
  const digits = phone.replace(/\D/g, '');

  // 2-digit country code + 10-digit number
  if (digits.length === 12) {
    return `+${digits.slice(0, 2)} ${digits.slice(2, 5)}-${digits.slice(5, 8)}-${digits.slice(8)}`;
  }

  // 3-digit country code + 10-digit number
  if (digits.length === 13) {
    return `+${digits.slice(0, 3)} ${digits.slice(3, 6)}-${digits.slice(6, 9)}-${digits.slice(9)}`;
  }

  // 4-digit country code + 10-digit number
  if (digits.length === 14) {
    return `+${digits.slice(0, 4)} ${digits.slice(4, 7)}-${digits.slice(7, 10)}-${digits.slice(10)}`;
  }

  return phone;
};
